var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"checkbox-hover"},[_c('input',_vm._g(_vm._b({staticClass:"check-custom",attrs:{"type":"checkbox"}},'input',_vm.$attrs,false),_vm.listeners)),_c('span',{staticClass:"check-toggle flex-none"})])}
var staticRenderFns = []

export { render, staticRenderFns }